module.exports = __webpack_public_path__ + "img/GoogleIconColorNoBg.eefda722.png";